import { mapState } from 'vuex'
import { isProduction } from '@/helpers'

export const analyticsMixin = {
    computed: {
        ...mapState(['userMetadata']),
        isAnalyticsEnabled() {
            return (this.userMetadata?.analytics_opt_in || !('analytics_opt_in' in this.userMetadata)) && isProduction()
        }
    }
}
